import { useEffect, useState } from 'react';

import { VIEWPORT_TRANSITION_MS } from '@/components/ViewportContainer/viewportConstants';

import type { DevicePreset } from '@/types/feedback';

/**
 * Shows a frame spinner only after the viewport resize animation, while the
 * preview iframe is still loading.
 */
export function useDelayedFrameSpinner(
  isReady: boolean,
  device: DevicePreset,
): boolean {
  const [delayedLoading, setDelayedLoading] = useState(false);

  useEffect(() => {
    if (isReady) return;

    const timer = window.setTimeout(() => {
      setDelayedLoading(true);
    }, VIEWPORT_TRANSITION_MS);

    return () => {
      window.clearTimeout(timer);
      setDelayedLoading(false);
    };
  }, [isReady, device]);

  return !isReady && delayedLoading;
}
